import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { admin as adminRoute, main } from 'routes/route.map'
import { Link, useHistory } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Dropdown,
  Button,
  buttonVariations,
  buttonSizes,
} from 'shared/components'
import { StoreContext } from 'store/context'
import { ROLES } from 'constants/account.roles'
import CustomIcon from 'shared/components/customIcon'
import BalanceAccess from '../balanceAccess'
import * as styles from './styles'
import { css } from '@emotion/core'
import { spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

const NavigationComponent = ({ appStore }) => {
  const history = useHistory()
  if (!appStore) return null

  const authStore = appStore.auth

  const { loggedEntity } = authStore
  const { toggleMenu, isMenuOpen } = appStore.appConfig
  const displayName = loggedEntity?.displayName
  const { auth } = useContext(StoreContext)
  const isAdmin = auth.loggedEntity?.role === ROLES.ADMIN
  const isBene = auth.loggedEntity?.role === ROLES.BENEFICIARY
  const isSponsor = auth.loggedEntity?.role === ROLES.SPONSOR

  const isDisabledInWinsAndBalance = isBene || isSponsor

  return (
    <nav css={styles.container}>
      <div>
        <div css={styles.MenuHeader}>
          <CustomIcon
            icon={isMenuOpen ? 'close' : 'burgerMenu'}
            style={styles.BurgerMenu}
            onClick={() => toggleMenu(!isMenuOpen)}
          />
          {!isMenuOpen && (
            <Link css={[styles.heading]} to={main}>
              <img src="./img/logoType.png" height={30} />
            </Link>
          )}
          {loggedEntity && isMenuOpen && (
            <Dropdown
              style={styles.FirstMenuDrop}
              items={[
                {
                  text: displayName,
                  icon: () => <FontAwesomeIcon size="1x" icon="user-circle" />,
                },
                ...(isAdmin
                  ? [
                    {
                      text: 'Admin Panel',
                      icon: () => null,
                      onClick: () => history.push(adminRoute.beneficiaries()),
                    },
                  ]
                  : []),
                {
                  text: 'Log out',
                  icon: () => (
                    <FontAwesomeIcon size="1x" icon="right-from-bracket" />
                  ),
                  onClick: () => auth.signout(),
                },
              ]}
            />
          )}
        </div>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        {!isDisabledInWinsAndBalance && (
          <BalanceAccess isVisible={!isMenuOpen} />
        )}
        <>
          {loggedEntity ? (
            <Dropdown
              style={styles.MenuDrop}
              items={[
                {
                  text: displayName,
                  icon: () => <FontAwesomeIcon size="1x" icon="user-circle" />,
                },
                ...(isAdmin
                  ? [
                    {
                      text: 'Admin Panel',
                      icon: () => null,
                      onClick: () => history.push(adminRoute.beneficiaries()),
                    },
                  ]
                  : []),
                {
                  text: 'Log out',
                  icon: () => (
                    <FontAwesomeIcon size="1x" icon="right-from-bracket" />
                  ),
                  onClick: () => auth.signout(),
                },
              ]}
            />
          ) : (
            <div css={styles.buttonContainer}>
              <Button
                size={buttonSizes.SMALL}
                variation={buttonVariations.SECONDARY}
                onClick={() => history.push('/auth/login')}
                text="Log in"
              />
              <Button
                css={css`
                  ${MQ.PHONES} {
                    padding-right: ${spacing(1.5)} !important;
                    padding-left: ${spacing(1.5)} !important;
                  }
                `}
                size={buttonSizes.SMALL}
                onClick={() => history.push('/auth/signup')}
                text="Sign up"
              />
            </div>
          )}
        </>
      </div>
    </nav>
  )
}

NavigationComponent.propTypes = {
  appStore: PropTypes.shape().isRequired,
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default observer(NavigationComponent)
